import React, { useEffect, useRef } from "react";
import { useAppDispatch } from "../../redux/configureStore";
import ContentWrapper from "./ContentWrapper";
import LoadingSpinner from "./LoadingSpinner";
import useLoadedData from "./useLoadedData";
import { ConfirmationRequest } from "../../app/types";
import Modals from "../modals/Modals";
import useConfirmation from "../modals/useConfirmation";

interface Props {
  children: React.ReactNode;
}

const errorAlert: ConfirmationRequest = {
  title: "Error",
  msg: "A problem occurred. \n\nOur developer team has been notified. \n\n Please try again.",
  acceptText: "Refresh",
  denyText: "Back",
};

const errorHandler = (userAccepted: boolean) => {
  if (userAccepted) {
    window.location.reload();
  } else {
    const pattern = /\/venue\/([^/\s]+)/;
    const match = window.location.href.match(pattern);
    if (match && match[1]) {
      window.location.href = `/Event/${match[1]}`;
    }
  }
};

const LoadingScreen = ({ children }: Props) => {
  const dispatch = useAppDispatch();
  const hasShownError = useRef(false);
  const showErrorAlert = useConfirmation(errorAlert, errorHandler);

  const { isError, isSuccess } = useLoadedData();

  useEffect(() => {
    if (isError && !hasShownError.current) {
      showErrorAlert();
      hasShownError.current = true;
    }
  }, [dispatch, isError, showErrorAlert]);

  if (isSuccess) {
    return <ContentWrapper>{children}</ContentWrapper>;
  }

  return (
    <div className="loadingContent">
      <div className="loadingSpinnerWrapper">
        <div className="loadingSpinner">
          <LoadingSpinner />
          <Modals />
        </div>
      </div>
      <style jsx>
        {`
          .loadingSpinnerWrapper {
            justify-content: center;
            align-items: center;
            width: 50vh;
            height: 50vh;
          }
          .loadingContent {
            background: #323232;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: auto;
          }
          .loadingContent p {
            color: white;
            font-size: 15vh;
            margin: 0;
          }
        `}
      </style>
    </div>
  );
};

export default LoadingScreen;
